import React from 'react';
import { useLocalization } from '@/Hooks';
import { MergeDiff } from '@/ModalWindows/MergeOrdersModal/modules/MergeDiff/MergeDiff';
import { Modal } from '@/Components/Modal/Modal';
import { ModalDialog } from '@/Components/ModalDialog/ModalDialog';
import { useMergeOrdersModal } from '@/ModalWindows/MergeOrdersModal/hooks/useMergeOrdersModal';
import { ModalProps } from '@/Types';

type Props = ModalProps;

export function MergeOrdersModal({ closeModalWindow }: Props) {
  const {
    buttons: { Yes, No },
    modalWindows: {
      mergeOrders: { Description, MergeConfirmText },
    },
  } = useLocalization();

  const { saveMergeResult, isDiffDialogShown, isConfirmDialogShown, difference, mergeOrders } = useMergeOrdersModal();

  return (
    <Modal
      onClose={closeModalWindow}
      modalId={'mergeOrdersModal'}
      tourKey={'mergeOrdersTour'}
      description={{
        title: Description.Title,
        text: Description.Text,
      }}
    >
      {isDiffDialogShown && <MergeDiff diff={difference} onCancel={closeModalWindow} onSave={saveMergeResult} />}
      {isConfirmDialogShown && (
        <ModalDialog
          title={Description.Title}
          text={MergeConfirmText}
          okButtonText={Yes}
          cancelButtonText={No}
          onClose={closeModalWindow}
          onOk={mergeOrders}
        />
      )}
    </Modal>
  );
}
